const getScrollMax = (elem: HTMLElement) => {
  // @ts-ignore
  const { scrollHeight, clientHeight, scrollTopMax } = elem

  // Non-standard, only exist on firefox
  if (scrollTopMax) {
    return scrollTopMax
  }

  return scrollHeight - clientHeight
}

export const shouldScrollToBottom = () => {
  const elem = document.getElementById('chat')
  if (!elem) {
    return false
  }

  const { scrollTop } = elem
  const maxScroll = getScrollMax(elem)

  // Scroll if the user is near the bottom
  return scrollTop > maxScroll * 0.8
}
